import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { CommonModule, registerLocaleData } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

// Modules
import { CheckoutModule } from './checkout/checkout.module';
import { PageNotFoundModule } from './page-not-found/page-not-found.module';
import { SelfAttendanceModule } from './self-attendance/self-attendance.module';
import { SnackBarModule } from './shared/components/snack-bar/snack-bar.module';
import { DisconnectedSaleModule } from './disconnected-sale/disconnected-sale.module';



// Services
import { DtmService } from './services/dtm.service';
import { CustomerService } from './shared/services/customer.service';
import { HttpService } from './shared/services/http.service';
import { SessionStorageService } from 'src/app/shared/services/session-storage.service';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {DevelopmentModule} from './development/development.module';
import {ECommerceService} from "./services/e-commerce.service";

import localePt from '@angular/common/locales/pt';
import { LoadingService } from './shared/services/loading.service';
import { FloatingFaqModule } from './floating-faq/floating-faq.module';
import { CookieService } from 'ngx-cookie-service';
import { SuggestionProductModalModule } from './shared/components/suggestion-product-modal/suggestion-product-modal.module';
import { DisconnectedSaleIdentificationModule } from './disconnected-sale/identification/identification.module';
import { DisconnectedSaleSuccessModule } from './disconnected-sale/success/success.module';
import { DisconnectedSalePaymentModule } from './disconnected-sale/payment/payment.module';


registerLocaleData(localePt);

@NgModule({ declarations: [
        AppComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        BrowserAnimationsModule,
        RouterModule,
        CommonModule,
        AppRoutingModule,
        CheckoutModule,
        DevelopmentModule,
        PageNotFoundModule,
        SelfAttendanceModule,
        DisconnectedSaleModule,
        SnackBarModule,
        FloatingFaqModule,
        SuggestionProductModalModule], providers: [
        CustomerService,
        DtmService,
        SessionStorageService,
        HttpService,
        ECommerceService,
        LoadingService,
        CookieService,
        {
            provide: LOCALE_ID,
            useValue: 'pt'
        },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }
